import { render, staticRenderFns } from "./TodasRedesSociais.vue?vue&type=template&id=d4dd7ed6&scoped=true"
import script from "./TodasRedesSociais.vue?vue&type=script&lang=js"
export * from "./TodasRedesSociais.vue?vue&type=script&lang=js"
import style0 from "./TodasRedesSociais.vue?vue&type=style&index=0&id=d4dd7ed6&prod&lang=css"
import style1 from "./TodasRedesSociais.vue?vue&type=style&index=1&id=d4dd7ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4dd7ed6",
  null
  
)

export default component.exports